import React, { useEffect } from 'react';
import { InviteCandidateProvider } from './Contexts/InviteCandidateContext';
import AddCandidatesPanel from './AddCandidatesPanel/AddCandidatesPanel';
import ChangesMaybeLostDialog from './Components/ChangesMaybeLostDialog';
import PreviewInvitationEmailDialog from './Components/PreviewInvitationEmailDialog';
import InvitationLinkPanel from './InvitationLinkPanel/InvitationLinkPanel';

const InviteCandidateContent = (): React.JSX.Element => {
    useEffect(() => {
        window.onbeforeunload = (event) => {
            event.preventDefault();
            return '';
        };
        return () => {
            window.onbeforeunload = null;
        };
    }, []);

    return (
        <InviteCandidateProvider>
            <div className="flex flex-col gap-6">
                <InvitationLinkPanel />
                <AddCandidatesPanel />
            </div>
            <PreviewInvitationEmailDialog />
            <ChangesMaybeLostDialog />
        </InviteCandidateProvider>
    );
};

export default InviteCandidateContent;
